import React from "react";
import { noop } from "../../utils";
export var initialValue = {
  active: false,
  setActive: noop
};
export var DropdownContext = React.createContext(initialValue);